<template>
  <div
    v-if="visible"
    class="modal-overlay"
    :style="{
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      background: 'rgba(0, 0, 0, 0.5)',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: 199
    }"
    @click.self="close"
  >
    <div
      class="modal-content"
      :style="{
        background: 'white',
        padding: '20px',
        borderRadius: '5px',
        minWidth: '900px',
        height: 'auto',
        zIndex: 100
      }"
      @click.stop
    >
      <slot></slot>
      <hr>
      <div class="actions">
        <action-button
          text="Close"
          @pressed="closeModal"
        ></action-button>
      </div>
    </div>
  </div>
</template>

<script>
import actionButton from "@/components/actionButton";

export default {
  name: "Modal",
  components: {actionButton},
   props: {
     visible: {
       type: Boolean,
       default: false
     }
   },
   emits: ['update:visible'],
   methods: {
    close() {
      this.$emit("update:visible", false);
    },
    closeModal() {
      this.close();
    }
  }
};
</script>

